import type { Dict } from "../core.js";
import type { ai as vi } from "../vi/ai.js";

export const ai: Dict<typeof vi> = {
  chooseApp: "Choose an app",
  featureCount: "{enabled}/{total} features enabled",
  appHint: "Settings for this app.",
  settingsSections: "AI settings sections",
  sync: "Sync",
  noLimits: "This app has no budget limits configured.",
  noSync: "This app has no configuration sync destination.",
  featuresHint: "Use the switch to enable or disable a feature. Choose Edit to change its model and cost cap.",
  syncHint: "Check which configuration the app has received. Push again only when needed.",
  featureOn: "Enabled",
  featureOff: "Disabled",
  edit: "Edit",
  enableFeature: "Enable this feature",
  featureId: "Feature ID",
  costSummary: "Up to {value} USD/call",
  costHint: "Leave empty to use the app default limit.",
  saveFeature: "Save changes",
  invalidCost: "The per-call cap must be greater than 0, or empty to use the default.",
  budgetTab: "Budget",
  title: "AI",
  titleForApp: "AI — {app}",
  intro: "Choose an app to manage AI features, models and budgets.",
  onlyForApp: "Showing {app} only.",
  seeAll: "See all apps",
  loadFailed: "Could not load AI settings.",
  saveFailed: "Could not save.",
  readOnly: "You have read-only access. Editing requires `hq.integrations.write`.",
  openrouter: "OpenRouter key",
  openrouterOn: "Bound to « {set} » · enabled",
  openrouterOff: "Bound to « {set} » · DISABLED — this app's AI does not run",
  openrouterMissing: "No OpenRouter credential set bound — this app's AI does not run",
  openrouterUntested: "set has not passed a test run",
  openrouterManage: "Manage key",
  features: "Features",
  feature: "Feature",
  enabled: "On",
  model: "Model",
  modelAppDefault: "App default",
  maxCost: "Cap per call (USD)",
  maxCostDefault: "default {value}",
  maxCostNone: "app policy",
  overridden: "changed",
  defaultState: "default",
  limits: "Budget & limits",
  limitsHint:
    "Leave empty = use the default. The app still counts its own spend and stops itself at the limit.",
  limitDefault: "default {value}",
  saveLimits: "Save limits",
  saving: "Saving…",
  "unit.usd": "USD",
  "unit.count": "calls",
  "unit.tokens": "tokens",
  "unit.bytes": "bytes",
  "unit.ms": "ms",
  "period.request": "per call",
  "period.day": "per day",
  "period.month": "per month",
  "period.window": "per window",
  "period.total": "total",
  invalidNumber: "« {label} » must be a non-negative number.",
};
